import {Text } from '@chakra-ui/react';

import MultipleSection from '../formSections/MultiSection';
import Start from '../formSections/Start';
import SingleSection from '../formSections/SingleSection';
import Menu from '../formSections/Menu';
import { getQuestionTemplateByQuestionType } from '../formControllers/utils';
import Preview from '../components/Preview';
import Parser from '../formSections/Parser';
import Interview from '../formSections/Interview';
import ParseLetter from '../formSections/ParseLetter';
import PreviewLetter from '../components/PreviewLetter';
import Aptitude from '../formSections/Aptitude';
import SubSection from '../formSections/Interview/components/SubSection';
import HollandCodeTest from '../formSections/Aptitude/HollandCodeTest';
import { handleTestComplete } from '../formSections/Aptitude/utils';
import MyersBriggsTest from '../formSections/Aptitude/MyersBriggsTest';
import ValuesAssessment from '../formSections/Aptitude/ValuesAssessment';
import DiscInventory from '../formSections/Aptitude/DiscInventory';
import InterviewCoachHome from '../formSections/Interview/coach';
import RSVideoUpload from '../formSections/Interview/coach/RSVideoUpload';

export const checkForSubQuestion = (qObj, props, secOrIndIndex) => {
  let found = false;
  for (let j = 0; j < qObj.conditionalGroups.length; j++) {
    const qConditionalGroup = qObj.conditionalGroups[j];
    for (let k = 0; k < qConditionalGroup.conditionals.length; k++) {
      const qConditionalSet = qConditionalGroup.conditionals[k];
      const pQid = qConditionalSet['parent'];
      const pConditional =
        props.formikProps.values.jobSeekerData[secOrIndIndex][pQid];
      const qConditional = qConditionalSet.conditional;
      if (pConditional === qConditional) {
        found = true;
      } else {
        found = false;
        break;
      }
    }
    if (found) {
      if (typeof qConditionalGroup.options !== 'undefined') {
        qObj.options = qConditionalGroup.options;
      }
      break;
    }
  }
  return found;
};

export const formatOption = option => {
  return (
    <option key={option.label} value={option.value}>
      {option.label}
    </option>
  );
};
export const formatOptionLabel = (value, label) => {
  return (
    <label htmlFor={value}>
      <Text fontWeight="400" pl={1} pr={6}>
        {label}
      </Text>
    </label>
  );
};
const getSectionDataProperty = (newSectionData, stateProps, attrName) => {
    const retVal = typeof newSectionData[attrName] !== 'undefined'
      ? newSectionData[attrName]
      : stateProps.sectionData[attrName];
  return retVal;
};
export const updateSectionData = (newSectionData, stateProps) => {
  stateProps.setSectionData({
    resumeIndex: getSectionDataProperty(
      newSectionData,
      stateProps,
      'resumeIndex',
    ),
    preview: getSectionDataProperty(
      newSectionData,
      stateProps,
      'preview',
    ),
    parsed: getSectionDataProperty(
      newSectionData,
      stateProps,
      'parsed',
    ),
    resumeIndustryName: getSectionDataProperty(
      newSectionData,
      stateProps,
      'resumeIndustryName',
    ),
    resumeToDelete: getSectionDataProperty(
      newSectionData,
      stateProps,
      'resumeToDelete',
    ),
    sectionName: getSectionDataProperty(
      newSectionData,
      stateProps,
      'sectionName',
    ),
    sectionIndex: getSectionDataProperty(
      newSectionData,
      stateProps,
      'sectionIndex',
    ),
    sectionType: getSectionDataProperty(
      newSectionData,
      stateProps,
      'sectionType',
    ),
    industryType: getSectionDataProperty(
      newSectionData,
      stateProps,
      'industryType',
    ),
    indIndex: getSectionDataProperty(newSectionData, stateProps, 'indIndex'),
    modalMessage: getSectionDataProperty(
      newSectionData,
      stateProps,
      'modalMessage',
    ),
    regenCS: getSectionDataProperty(
      newSectionData,
      stateProps,
      'regenCS',
    ),
    fileUrl: getSectionDataProperty(
      newSectionData,
      stateProps,
      'fileUrl',
    ),
    guid: getSectionDataProperty(newSectionData, stateProps, 'guid'),
  });
};


export const getQuestion = (props, qObj, key,index, isMultipart) => {
  qObj.index = index;

  if (
    (props.stateProps.sectionData.sectionType === 'industry' &&
      qObj.isIndustry) ||
    (props.stateProps.sectionData.sectionType !== 'industry' &&
      !qObj.isIndustry)
  ) {
    return getQuestionTemplateByQuestionType(props, qObj, index, isMultipart);
  } else {
    return null;
  }
};

export const spliceArray = (arrayToSplice, options) => {
  //const finalArray = [];
  const itemsToRemove = [];
  for (const option of options) {
    for (let i = 0; i < arrayToSplice.length; i++) {
      const item = arrayToSplice[i];
      if (item.key === option.key) {
        itemsToRemove.push(item);
      }
    }

  }

  return arrayToSplice.filter((element) => !itemsToRemove.includes(element));
};


export const getTextFromPreviousAnswer = (haystack, props) => {
  const start = haystack.indexOf('{') + 1;
  const end = haystack.lastIndexOf('}');
  if (end > 0) {
    const replacements = haystack.slice(start, end).split('.');
    const section = replacements[0];
    const field = replacements[1];
    const type =
      typeof replacements[2] !== 'undefined' ? replacements[2] : null;

    const index =
      section === 'resumes'
        ? props.stateProps.sectionData.resumeIndex
        : props.stateProps.sectionData.sectionIndex;
    let replacement =
      typeof props.stateProps.dataToSave.saved[section] !== 'undefined'
        ? props.stateProps.dataToSave.saved[section][index][field]
        : '';
    if (type === 'label') {
      //question_parts
      dance: for (const questionObj of props.navSections[section][
        'question_parts'
        ]) {
        if (questionObj.qid === field) {
          /**shamelessd hack**/
          if (field === 'job_title') {
            let jt =props.stateProps.dataToSave.saved['resumes'][index]['job_title'];

            questionObj.options = [{
              value: jt,
              industry: props.stateProps.dataToSave.saved['resumes'][index]['industry'],
            }];
          }
          /**end shameless**/
          for (const answerObj of questionObj.options) {
            if (answerObj.value === replacement[0]) {
              replacement = answerObj.label;
              break dance;
            }
          }
        }
      }
    }
    const needle =
      type === null
        ? '{' + section + '.' + field + '}'
        : '{' + section + '.' + field + '.' + type + '}';
    haystack = haystack.replace(needle, replacement);
  }
  return haystack;
};

export const getSectionType = (props, formikProps) => {
  const stateProps = props.stateProps;
  const sectionData = stateProps.sectionData;
  let sectionName = sectionData.sectionName;
  const parsed = sectionData.parsed;
  switch (sectionName) {
    case 'preview':
      return <Preview props={props} />;
    case 'parse-letter':
      return <ParseLetter props={props}/>
    case 'preview-letter':
      return <PreviewLetter props={props}/>
    case 'parser':
      if(parsed === false) {
        return <Parser props={props} />
      } else {
        return <Menu navSections={props.navSections} props={props} formikProps={formikProps} />;
      }
    case 'menu':
      return <Menu navSections={props.navSections} props={props} formikProps={formikProps} />;
    case 'menu-ex':
      return <Menu navSections={props.navSections} props={props} formikProps={formikProps} />;
  }

  if (sectionName === 'parser') {
      return (
        <Parser props={props} />
      )
  }
  if (sectionName === 'menu') {
    return (
      <Menu navSections={props.navSections} props={props} formikProps={formikProps} />
    )
  }
  if(sectionName === 'values-assessment') {
    return (
      <ValuesAssessment props={props} onComplete = {handleTestComplete()} />
    );
  }
  if(sectionName === 'disc-inventory') {
    return (
      <DiscInventory props={props} onComplete = {handleTestComplete()} />
    );
  }
  if(sectionName === 'holland-code') {
    return (
      <HollandCodeTest props={props} onComplete = {handleTestComplete()} />
    );
  }
  if(sectionName === 'myers-briggs') {
    return (
      <MyersBriggsTest props={props} onComplete = {handleTestComplete()} />
    );
  }
  if (sectionName === 'interview' || sectionName === 'interview-city') {
    const navSection =
      props.navSections[props.stateProps.sectionData.sectionName];
    return( <Interview props={props} navSection={navSection} /> )
  }
  if (sectionName === 'interview-coach-home') {
    return( <InterviewCoachHome props={props}  /> )
  }
  if (sectionName === 'interview-coacher') {
    return( <RSVideoUpload  props={props}  /> )
  }
  if (sectionName === 'interview-sparl' || sectionName === 'interview-you' || sectionName === 'interview-questions' || sectionName==='grow-goals') {
    const navSection =
      props.navSections[props.stateProps.sectionData.sectionName];
    return( <SubSection props={props} /> )

  }
  if (sectionName === 'new-aptitude') {
    const navSection =
      props.navSections[props.stateProps.sectionData.sectionName];
    return( <Aptitude props={props}  /> )
  }
  if (sectionName === 'menu-ex') {
    return (
    <Menu navSections={props.navSections} props={props} formikProps={formikProps} />
  )
  }
  if (!props.handlers.isMultiSection(props)) {
    const navSection =
      props.navSections[props.stateProps.sectionData.sectionName];
    return (<SingleSection props={props} formikProps={formikProps} navSection={navSection} index={0} />);
  } else {
    if (props.stateProps.sectionData.sectionType === 'industry') {
      const indIndex = props.stateProps.sectionData.indIndex;
      const navSection =
        props.stateProps.dataToSave.industry['other'];
      return (<SingleSection props={props} formikProps={formikProps} navSection={navSection} index={indIndex} />);
    } else {
      if (props.stateProps.sectionData.sectionName === 'resumes') {
        return (<Start props={props} formikProps={formikProps}/>)
      } else {
        return MultipleSection(props, formikProps);
      }
    }
  }
};
